<template>
  <div :class="[$style.fluidFlexbox, $style.mainContainer]">
    <CircledCharacter>
      {{ stepNumber }}
    </CircledCharacter>
    <div :class="$style.flex1">
      <div :class="[$style.infoRow, $style.fluidFlexbox]">
        <div :class="$style.rowContent">
          <HeadingSmall>
            Customer Information
          </HeadingSmall>
          <div
            v-if="!isMinimized"
            :class="$style.fluidFlexbox"
            data-test-id="BillingInformationReview__customerInfoBody"
          >
            <div :class="$style.flex1">
              <InputLabel text="Mailing Address" />
              <ParagraphBody
                bodySize="small"
                data-test-id="BillingInformationReview__mailingAddress"
              >
                <ul :class="$style.address">
                  <li
                    v-for="row of mailingAddressRows"
                    :key="row"
                  >
                    {{ row }}
                  </li>
                </ul>
              </ParagraphBody>
            </div>
            <div :class="$style.flex1">
              <InputLabel text="Email Address" />
              <ParagraphBody
                bodySize="small"
                data-test-id="BillingInformationReview__emailAddress"
              >
                {{ paymentDetails.billing.email }}
              </ParagraphBody>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!isMinimized"
        :class="[$style.infoRow, $style.fluidFlexbox]"
        data-test-id="BillingInformationReview__paymentInfo"
      >
        <div :class="[$style.rowContent, $style.paymentInfoRow]">
          <div :class="$style.fluidFlexbox">
            <div :class="$style.flex1">
              <InputLabel text="Billing Address" />
              <ParagraphBody
                bodySize="small"
                data-test-id="BillingInformationReview__billingAddress"
              >
                <ul :class="$style.address">
                  <li
                    v-for="row of billingAddressRows"
                    :key="row"
                  >
                    {{ row }}
                  </li>
                </ul>
              </ParagraphBody>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isMinimized && hasReachedSection">
      <IconButton
        data-test-id="BillingInformationReview__editButton"
        hasNoBackground
        hasOutline
        icon="edit"
        text="edit"
        type="informational"
        @click="handleEdit"
      />
    </div>
  </div>
</template>

<script>
import {
  HeadingSmall,
  IconButton,
  InputLabel,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import CircledCharacter from 'client/Payments/newComponents/CircledCharacter.vue';

export default {
  name: 'BillingInformationReview',

  components: {
    CircledCharacter,
    HeadingSmall,
    IconButton,
    InputLabel,
    ParagraphBody,
  },

  props: {
    hasReachedSection: Boolean,
    isMinimized: Boolean,
    // expecting the item from PaymentModel
    paymentDetails: {
      type: Object,
      required: true,
      validator: (value) => {
        const keys = Object.keys(value);
        return keys.includes('billing');
      },
    },
    stepNumber: {
      type: Number,
      required: true,
    },
  },

  computed: {
    billingAddressRows() {
      return [
        this.paymentDetails.card.cardholderName,
        ...this.getAddress(this.paymentDetails.card),
      ];
    },

    mailingAddressRows() {
      return [
        this.paymentDetails.billing.contactName,
        ...this.getAddress(this.paymentDetails.billing),
      ];
    },
  },

  methods: {
    getAddress(obj) {
      const region = obj.region ? `${obj.region} ` : '';
      return [
        `${obj.address1} ${obj.address2}`,
        `${obj.city}, ${region}${obj.postalCode}`,
      ];
    },

    handleEdit() {
      this.$emit('edit');
    },
  },
};
</script>

<style module scoped>
.fluidFlexbox {
  display: flex;
  width: 100%;
}

.infoRow {
  gap: var(--jc-spacer);
}

.mainContainer {
  gap: var(--jc-spacer);
}

.paymentInfoRow {
  margin-top: var(--jc-spacer);
}

.rowContent {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
}

.flex1 {
  flex: 1 1 0;
}

.address {
  list-style: none;
  margin: 0;
  padding: 0;
}
</style>
